import React, { useEffect, useState } from "react";
import API from "../api";
import { useAuth } from "../context/AuthContext";
import { Button, Alert } from "react-bootstrap";
import Select from "react-select";

export default function ScorecardPrintPage() {
  const { user } = useAuth();
  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    const fetchWeeks = async () => {
      if (!user?.leagueid) return;
      try {
        const res = await API.get(`/league/${user.leagueid}/weeks`);
        setWeeks(res.data);
      } catch (err) {
        console.error("Failed to fetch weeks", err);
      }
    };
    fetchWeeks();
  }, [user?.leagueid]);




const handlePrint = () => {
  console.log("Button clicked");
  if (!selectedWeek || !user?.leagueid) return;
  const url = `https://www.golfleaguemgr.com/api/scorecard/${user.leagueid}/weeknum/${selectedWeek}`;
  setPreviewUrl(url);
};








  const weekOptions = weeks.map((week) => ({
    value: week.week_number,
    label: `Week ${week.week_number} — ${(week.date)}`
  }));

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Generate Scorecards</h4>

      {!user?.leagueid ? (
        <Alert variant="warning">You are not assigned to a league.</Alert>
      ) : (
        <div style={{ maxWidth: "400px" }}>
          <label className="form-label">Select Week</label>
          <Select
            options={weekOptions}
            value={weekOptions.find((opt) => opt.value === selectedWeek)}
            onChange={(option) => setSelectedWeek(option.value)}
            placeholder="-- Choose a week --"
            styles={{
              menu: (base) => ({ ...base, maxHeight: 200 }),
              menuList: (base) => ({ ...base, maxHeight: 200, overflowY: "auto" })
            }}
          />

          <Button
            className="mt-3"
            variant="primary"
            onClick={handlePrint}
            disabled={!selectedWeek}
          >
            Generate Scorecards
          </Button>
        </div>
      )}

      {previewUrl && (
        <div className="mt-4">
          <h5>Preview</h5>
          <iframe
            title="Scorecard Preview"
            src={previewUrl}
            width="100%"
            height="800px"
            style={{ border: "1px solid #ccc" }}
          />
        </div>
      )}
    </div>
  );
}
